var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[_c('img',{staticClass:"logo",attrs:{"src":require("../assets/logo.png"),"alt":"logo"}}),_c('h2',{staticClass:"marginRight"},[_vm._v("estimate-me")]),(_vm.roomName)?_c('h2',{staticClass:"marginRight"},[_vm._v("room: '"+_vm._s(_vm.roomName)+"'")]):_vm._e(),_c('SettingsPanel',_vm._g({},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }